/**
 * @description 모니터링 관련 쿼리 키 모음
 * cpu: CPU 사용량 조회 키
 * memory: 메모리 사용량 조회 키
 * disk: 디스크 사용량 조회 키
 * network: 네트워크 사용량 조회 키
 * storage: 스토리지 사용량 조회 키
 * errorRate: Kubernetes API Server 에러율 조회 키
 * podOverview: Pod 전체 메트릭 조회 키
 * availableWorkers: 사용 가능한 워커 목록 조회 키
 * gpuMetric: GPU 메트릭 조회 키
 */

export const monitoringKeys = {
  all: ['monitoring'] as const,

  cpuPrefix: () => [...monitoringKeys.all, 'cpu'] as const,
  cpu: () => [...monitoringKeys.cpuPrefix()] as const,

  memoryPrefix: () => [...monitoringKeys.all, 'memory'] as const,
  memory: () => [...monitoringKeys.memoryPrefix()] as const,

  diskPrefix: () => [...monitoringKeys.all, 'disk'] as const,
  disk: () => [...monitoringKeys.diskPrefix()] as const,

  networkPrefix: () => [...monitoringKeys.all, 'network'] as const,
  network: () => [...monitoringKeys.networkPrefix()] as const,

  storagePrefix: () => [...monitoringKeys.all, 'storage'] as const,
  storage: () => [...monitoringKeys.storagePrefix()] as const,

  errorRatePrefix: () => [...monitoringKeys.all, 'errorRate'] as const,
  errorRate: () => [...monitoringKeys.errorRatePrefix()] as const,

  podOverviewPrefix: () => [...monitoringKeys.all, 'podOverview'] as const,
  podOverview: () => [...monitoringKeys.podOverviewPrefix(), 'allMetrics'] as const,

  availableWorkersPrefix: () => [...monitoringKeys.all, 'available-workers'] as const,
  availableWorkers: () => [...monitoringKeys.availableWorkersPrefix()] as const,

  gpuMetricPrefix: () => [...monitoringKeys.all, 'gpuMetric'] as const,
  gpuMetric: (metricType: string, hostname: string) =>
    [...monitoringKeys.gpuMetricPrefix(), metricType, hostname] as const,
} as const;
